export const makeMaskedNumbersScreenReadable = (text: string | undefined) => {
  // separating numbers in an address by space helps screen readers enunciate them better.
  return text?.split('').join(' ');
};
